<script lang="ts">
  import Button from "../shared/inputs/button/Button.svelte";

  export let options: {
    formattedBalance: string
    balance: number
    credAlias: string
    onPay: () => void
    onGetCred: () => void
    totalToPay: string
    isLoading: boolean
    isPaymentDisabled: boolean
  }

  let { credAlias, onPay, onGetCred } = options

  $: isLoading = options.isLoading
  $: isPaymentDisabled = options.isPaymentDisabled
  $: formattedBalance = options.formattedBalance
  $: totalToPay = options.totalToPay
  $: balance = options.balance
</script>

<div class="crtw-w-full crtw-text-center crtw-my-5">
  <div class="crtw-text-3xl crtw-text-black crtw-font-bold">
    {#if Number(totalToPay) > balance}
      INSUFFICIENT FUNDS
    {:else}
      {formattedBalance} {credAlias}
    {/if}
    
  </div>
  <div class="crtw-mb-5 crtw-text-gray-600">
    {#if Number(totalToPay) > balance}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
        You do not have enough stored value to make this payment. 
      <span
        class="crtw-text-black crtw-cursor-pointer"
        role="button"
        tabindex="0"
        on:click={onGetCred}
      >
        Click to get some {credAlias}
      </span>
    {:else}
      Your balance after purchase
    {/if}
  </div>

  <Button
    text={`Pay ${totalToPay} ${credAlias}`}
    onClick={onPay}
    disabled={isPaymentDisabled}
    {isLoading}
  />
</div>